import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Wrapper } from './style';

// components
import CloseIcon from '@mui/icons-material/Close';
import Link from 'components/common/Link';
import Image from 'next/image';

// Actions
import { setAppPromptCloseAction } from 'redux/core/actions';

// Libs
import Translation from 'libs/Translation';

const AppPrompt = ({ webConfig }) =>{
    const dispatch = useDispatch();
	const [closePrompt, setClosePrompt] = useState(false);

    const handleClosePopup = () => {
		dispatch(setAppPromptCloseAction(true));
		setClosePrompt(true);
	};

    return(
		<>
		{!closePrompt &&
		<Wrapper>
			<Link 
				className="row-flex"
				to='/landing'
				params={webConfig.lang !== 'fa' ? {lang: webConfig.lang} : {}}
			>
				<Image
					src="/nextasset/images/app-icon.png"
					width={55}
					height={55}
					alt="vclinic-app-icon"
				/>
				<span 
					className="button"
				>
					{Translation.t("label.download-app")}
				</span>
			</Link>
			<CloseIcon 
				onClick={handleClosePopup}
				className="icon"
			/>
 		</Wrapper>
		}
		</>
	)
}

export default AppPrompt;
